import useMountedRef from "../../utils/useMountedRef";
import { flowCopy } from "../../utils/flowCopy";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  removeRecord,
  getRecordedList,
  getWillBeRecordedList,
  getRecordList
} from "../../api/npvr/npvr";
import ModalPortal from "../../components/modalPortal";
import ProgramDetail from "../../components/programDetail";
import RecordItem from "../../components/recordItem";
import localizationStrings from "../../statics/localization";
import { sendCustomNpvrReport } from "../../utils/reporting/customReporting";
import recordImg from "../../assets/icons/svg/Icon awesome-angle-right.svg";
import { useHistory, useLocation } from "react-router-dom";
import TrashIcon from "../../assets/icons/svg/TrashIcon";
import ToBeReacordIcon from "../../assets/icons/svg/ToBeReacordIcon";
import RecordedIcon from "../../assets/icons/svg/RecordedIcon";
import CinemaIcon from "../../components/cinema/CinemaIcon";
import { getCinemaCopy } from "../../statics/cinemaCopy";
import EyeIcon from "../../assets/icons/svg/EyeIcon";
import useOutsideClick from "../../utils/useOutsideClick";
import useCarouselScroll from "../../utils/useCarouselScroll";
import { SessionContext } from "../../context/SessionContext";
import Notification from "../../components/notification";
import { toTrackId } from "../../analytics/trackIds";

const Record = ({
  onHoverProgramItem,
  recordRefreshCounter,
  selectedRecordItem,
  setSelectedRecordItem
}) => {
  const copy = getCinemaCopy();
  const [records, setRecords] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [selectedProgramCode, setSelectedProgramCode] = useState(null);
  const [selectedProgramdDetail, setSelectedProgramDetail] = useState(null);
  const {
    setSelectedCutvProgram,
    selectedChannel,
    userFrameConfig,
    userInfo,
    setPlayUrl,
    playUrl,
    hasLoggedIn
  } = useContext(SessionContext);
  const deleteCount = useRef(0);
  const allRecords = useRef([]);
  const filterType = useRef("-1");
  const optionRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const timeoutRef = useRef(null);
  const mounted = useMountedRef();
  const generation = useRef(0);
  const [loadError, setLoadError] = useState(false);

  useOutsideClick(optionRef, () => {
    setShowOptions(false);
  });
  const [viewport, setViewport] = useState(window.innerWidth);
  useEffect(() => {
    const resize = () => setViewport(window.innerWidth);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);
  const slidesToShow = viewport < 600 ? 1.4 : viewport < 1000 ? 2.4 : 4.4;
  const { trackRef, canPrevious, canNext, move, reset } = useCarouselScroll({
    itemCount: records.length,
    resetKey: filterType.current,
    onInteraction: () => onHoverProgramItem?.(false)
  });
  const getRecords = () => getAllRecords(filterType.current);

  const onSelectRecord = (item) => {
    setSelectedRecord(item);
    setShowModal(true);
    setSelectedProgramCode(item?.epgProgramId);
    setSelectedProgramDetail(item);
  };

  const closeRecordModal = (isRefresh) => {
    if (isRefresh) {
      setRecords([]);
      getRecords();
    }
    setShowModal(false);
  };

  const getAllRecords = async (type = filterType.current) => {
    const version = ++generation.current;
    setLoadError(false);
    try {
    const requests = type === "1" ? [getRecordedList()] : type === "0" ? [getWillBeRecordedList()] : [getRecordList()];
    const responses = await Promise.all(requests);
    if (responses.some(response => response?.status !== 200 || !Array.isArray(response.data))) throw new Error("Record list unavailable");
    const records = responses.flatMap(response => response.data);
    if (!mounted.current || version !== generation.current) return;
    allRecords.current = records;
    setRecords(records);
    reset();
    } catch (e) { if (mounted.current && version === generation.current) setLoadError(true); }
  };

  const filterRecords = (type) => {
    filterType.current = type;
    setShowOptions(false);
    getAllRecords(type);
  };

  const removeOne = item => removeRecord(item.epgProgramId, false,
    item.npvrRecordUId || item.UId || item.id, item.channelUId || item.ChannelUId);

  const deleteSingleRecord = async item => {
    try {
      await removeOne(item);
      if (mounted.current) await getRecords();
    } catch (e) { if (mounted.current) setLoadError(true); }
  };

  const deleteAllRecords = async () => {
    setShowNotification(false);
    try {
      for (const item of allRecords.current) await removeOne(item);
      if (mounted.current) await getRecords();
    } catch (e) {
      if (mounted.current) {
        await getRecords();
        setLoadError(true);
      }
    }
  };

  const renderedItems = records.map((item, index) => {
    const uniqueKey = `${item?.npvrcode}-${index}`;
    return (
      <RecordItem
        key={uniqueKey}
        item={item}
        trackId={toTrackId("card", "my_records", index + 1)}
        title={item?.title}
        onSelect={onSelectRecord}
        deleteRecord={deleteSingleRecord}
        isFirst={index == 0}
        onHoverProgramItem={onHoverProgramItem}
      />
    );
  });

  // useEffect(() => {
  //   getRecords();
  // }, [recordRefreshCounter]);

  useEffect(() => {
    if (filterType.current) {
      getAllRecords(filterType.current);
    }
    return () => { generation.current++; };
  }, [recordRefreshCounter]);

  useEffect(() => {
    if (selectedRecordItem) {
      setShowModal(true);
    }
    setSelectedRecord(selectedRecordItem?.record);
  }, [selectedRecordItem]);

  useEffect(() => {
    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div
      className="content-carousel cinema-record-shelf"
      style={{
        display: !allRecords.current?.length && !loadError ? "none" : ""
      }}
    >
      {loadError && <p role="alert">{flowCopy().loadError} <button onClick={() => getAllRecords()}>{flowCopy().retry}</button></p>}
      <div className="cinema-record-heading">
        <label
          className="label-title"
          role="link"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              history.push(
                `/dashboard/genre/record/${localizationStrings.myRecords}`
              );
            }
          }}
          onClick={() =>
            history.push(
              `/dashboard/genre/record/${localizationStrings.myRecords}`
            )
          }
        >
          {localizationStrings.myRecords}
          <img className="see-all-icon" src={recordImg} alt="" />
        </label>

        <div className="cinema-record-controls">
          <button
            type="button"
            className="cinema-icon-button"
            aria-label={`${copy.previous}: ${localizationStrings.myRecords}`}
            disabled={!canPrevious}
            onClick={() => move(-1)}
          >
            <CinemaIcon name="previous" />
          </button>
          <button
            type="button"
            className="cinema-icon-button"
            aria-label={`${copy.next}: ${localizationStrings.myRecords}`}
            disabled={!canNext}
            onClick={() => move(1)}
          >
            <CinemaIcon name="next" />
          </button>
          <div
            ref={optionRef}
            className="dot-options"
            onClick={(e) => {
              e.stopPropagation();
              setShowOptions(!showOptions);
            }}
          >
            <div className="dots-wrapper" style={{ right: "0px" }}>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>

              <div className={`options-box ${showOptions ? "show" : ""}`}>
                <div className="tri-angle"></div>
                <div className="options">
                  {filterType.current !== "1" ? (
                    <div className="option" onClick={() => filterRecords("1")}>
                      <RecordedIcon />
                      <span>{localizationStrings.recordeds}</span>
                    </div>
                  ) : null}

                  {filterType.current !== "0" ? (
                    <div className="option" onClick={() => filterRecords("0")}>
                      <ToBeReacordIcon />
                      <span>{localizationStrings.willRecord}</span>
                    </div>
                  ) : null}
                  {filterType.current !== "-1" ? (
                    <div className="option" onClick={() => filterRecords("-1")}>
                      <EyeIcon />
                      <span>{localizationStrings.seeAll}</span>
                    </div>
                  ) : null}
                  <div
                    className="option"
                    onClick={() => setShowNotification(true)}
                  >
                    <TrashIcon />
                    <span>{localizationStrings.deleteAll}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="cinema-scroll-track"
        ref={trackRef}
        style={{ "--carousel-item-width": `${100 / slidesToShow}%` }}
      >
        {renderedItems}
      </div>

      {showModal ? (
        <ModalPortal viewClass="vod-modal">
          <ProgramDetail
            prevueCode={selectedProgramCode}
            closeModal={(val, isRefresh) => {
              setShowModal(false);
              if (isRefresh) getAllRecords();
            }}
            fromLive={true}
            setSelectedCutvProgram={setSelectedCutvProgram}
            selectedChannel={selectedChannel}
            userFrameConfig={userFrameConfig}
            userInfo={userInfo}
            location={location}
            history={history}
            programData={selectedProgramdDetail}
            isRecord={true}
            setPlayUrl={setPlayUrl}
            playUrl={playUrl}
            hasLoggedIn={hasLoggedIn}
          />
        </ModalPortal>
      ) : null}

      {showNotification ? (
        <Notification
          text={localizationStrings.deleteRecordConfirmText}
          confirmText={localizationStrings.delete}
          notConfirmText={localizationStrings.cancel}
          onClickConfirm={() => {
            deleteAllRecords();
          }}
          onClickNotConfirm={() => setShowNotification(false)}
        />
      ) : null}
    </div>
  );
};

export default Record;
